<template>
  <div class="box10-page">
    <pageTitle
      title="顺势而为 你也可以"
      text="现在仍是入行好时机！"
    />
    <ul>
      <li 
        v-for="(item, index) in list" 
        :key="index"
        :style="{backgroundImage: `url(${require('../../../assets/coursePage/newMedia2/box10/' + (index + 1) + '.png')})`}"
      >
        <h2>{{ item.title }}</h2>
        <p>{{ item.info }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
  export default {
    name: '',
    components: {
      pageTitle,
    },
    data() {
      return {
        list:[
          {
            title: '创业老板/向往自由的人群',
            info: '有货源/无货源创业人群，无运营能力，需快速获取流量。追求更灵活、更自由轻松工作环境的自由职业者。'
          },
          {
            title: '稳定上班族',
            info: '有较稳定工作，想充分利用业余时间发展副业，增加保障，拓宽收入。'
          },
          {
            title: '具备某方面能力特长人群',
            info: '在某领域有一定特长或经验，有明显个性化特征人群，更容易快速上手。'
          },
          {
            title: '不便进入职场人群',
            info: '宝妈、退休老人等不具备进入职场条件的人群，在家也能玩网络，创收入！'
          },
          {
            title: '初入职场迷茫者',
            info: '初入新媒体行业，把控不了准确的运营节奏，需要专业人士陪跑、指导，快速升职加薪。'
          }
        ]
      }
    }
  }
</script>

<style lang="scss" scoped>
.box10-page{
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/newMedia2/box10/bgc.png") no-repeat;
  background-size: cover;
  box-sizing: border-box;
  ul{
    padding-top: 50px;
    li{
      padding: 22px 0 22px 170px;
      margin: 0 auto 30px;
      width: 690px;
      background-color: #ffffff;
      box-shadow: 0px 0px 30px 0px 
        rgba(229, 184, 199, 0.4);
      border-radius: 20px;
      background-repeat: no-repeat;
      background-position: 0px 10px;
      background-size: 158px 158px;
      box-sizing: border-box;
      h2{
        font-family: PingFang-SC-Bold;
        font-size: 26px;
        font-weight: bold;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #000000;
        margin-bottom: 6px;
      }
      p{
        font-family: PingFang-SC-Regular;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 36px;
        letter-spacing: 0px;
        color: #253326;
      }
    }
  }
}
</style>